import { getWeekDay } from "../util/calendarutil"

function CalendarHovercard({ events }) {

  let content = events.map((e, i) => {
    return (
      e.eventurl === "" ?
        <p className="ncal-hovercard-p" key={i}>{e.eventtext}</p>
        :
        <a className="ncal-hovercard-link" key={i} href={e.eventurl}>
          <p className="ncal-hovercard-p">{e.eventtext}</p>
        </a>
    )
  }
  )

  const weekday = getWeekDay(events[0].date)

  let style = {
    "--offset-left-container": `${-30 - weekday * 25}px`,
    "--offset-left-symbol": `${30 + weekday * 25}px`
  };

  return (
    <div className="ncal-hovercard-eventcontainer" style={style}>
      <div className="ncal-hovercard-content">
        {content}
      </div>
    </div>
  )
}

export default CalendarHovercard